export function cx(...parts) {
  return parts.filter(Boolean).join(' ');
}

export const cardSurfaceClass = 'card-surface';

export const severityBorderClasses = {
  critical: 'border-red-500',
  warning: 'border-amber-500',
  good: 'border-emerald-500',
  accent: 'border-violet-500',
  neutral: 'border-slate-300',
};

export const valueToneClasses = {
  critical: 'text-red-600',
  warning: 'text-amber-600',
  good: 'text-emerald-600',
  accent: 'text-violet-600',
  neutral: 'text-slate-900',
};

export const badgeToneClasses = {
  critical: 'status-badge status-badge-red',
  warning: 'status-badge status-badge-amber',
  good: 'status-badge status-badge-green',
  blue: 'status-badge status-badge-blue',
  orange: 'status-badge status-badge-amber',
  yellow: 'status-badge status-badge-amber',
  red: 'status-badge status-badge-red',
  green: 'status-badge status-badge-green',
  slate: 'status-badge status-badge-slate',
};

export const circleThemes = {
  HP: {
    accentDot: 'bg-blue-600',
    tabActive: 'border-blue-200 bg-blue-50 text-slate-900 shadow-[0_10px_18px_rgba(37,99,235,0.08)]',
    tabText: 'text-blue-700',
    panelRing: 'ring-blue-100',
    headerAccent: 'bg-blue-600',
  },
  JA: {
    accentDot: 'bg-red-600',
    tabActive: 'border-red-200 bg-red-50 text-slate-900 shadow-[0_10px_18px_rgba(220,38,38,0.08)]',
    tabText: 'text-red-700',
    panelRing: 'ring-red-100',
    headerAccent: 'bg-red-600',
  },
  KS: {
    accentDot: 'bg-violet-600',
    tabActive: 'border-violet-200 bg-violet-50 text-slate-900 shadow-[0_10px_18px_rgba(124,58,237,0.08)]',
    tabText: 'text-violet-700',
    panelRing: 'ring-violet-100',
    headerAccent: 'bg-violet-600',
  },
  UW: {
    accentDot: 'bg-amber-600',
    tabActive: 'border-amber-200 bg-amber-50 text-slate-900 shadow-[0_10px_18px_rgba(217,119,6,0.08)]',
    tabText: 'text-amber-700',
    panelRing: 'ring-amber-100',
    headerAccent: 'bg-amber-600',
  },
};

export const domainHeaderClasses = {
  fiber: 'border-blue-100 bg-blue-50 text-blue-900',
  tower: 'border-slate-200 bg-slate-50 text-slate-800',
  osc: 'border-sky-100 bg-sky-50 text-sky-900',
  mfl: 'border-violet-100 bg-violet-50 text-violet-900',
  'pm-fiber': 'border-emerald-100 bg-emerald-50 text-emerald-900',
  'pm-tower': 'border-stone-200 bg-stone-50 text-stone-800',
  'pm-osc': 'border-rose-100 bg-rose-50 text-rose-900',
  'pm-mfl': 'border-indigo-100 bg-indigo-50 text-indigo-900',
};

export const insightToneClasses = {
  critical: {
    border: 'border-red-500',
    exposure: 'text-red-500',
  },
  warning: {
    border: 'border-amber-500',
    exposure: 'text-amber-600',
  },
  good: {
    border: 'border-emerald-500',
    exposure: 'text-emerald-600',
  },
  accent: {
    border: 'border-violet-500',
    exposure: 'text-violet-600',
  },
};

export const domainPillClasses = {
  fiber: 'bg-blue-50 text-blue-700',
  tower: 'bg-slate-100 text-slate-600',
  osc: 'bg-sky-50 text-sky-700',
  mfl: 'bg-violet-50 text-violet-700',
  'pm-fiber': 'bg-emerald-50 text-emerald-700',
  'pm-tower': 'bg-stone-100 text-stone-700',
  'pm-osc': 'bg-rose-50 text-rose-700',
  'pm-mfl': 'bg-indigo-50 text-indigo-700',
};

export function resolveLegendDotClass(label) {
  if (label.startsWith('Fiber')) return 'bg-blue-700';
  if (label.startsWith('Tower')) return 'bg-slate-600';
  if (label.startsWith('OSC')) return 'bg-sky-700';
  if (label.startsWith('MFL') || label.startsWith('Standalone')) return 'bg-violet-700';
  if (label.startsWith('FTTX')) return 'bg-teal-500';
  return 'bg-teal-500';
}

export function formatSectionToneLabel(tone) {
  const labels = {
    fiber: 'Fiber',
    tower: 'Tower',
    osc: 'OSC',
    mfl: 'MFL / Standalone',
    'pm-fiber': 'Fiber PM',
    'pm-tower': 'Tower PM',
    'pm-osc': 'OSC PM',
    'pm-mfl': 'Standalone / MFL PM',
  };

  return labels[tone] || tone;
}

export function standardizeZoneSeverityLabel(tone) {
  if (tone === 'critical' || tone === 'red') return 'Critical';
  if (tone === 'warning' || tone === 'orange' || tone === 'yellow') return 'Elevated';
  if (tone === 'good' || tone === 'green') return 'Managed';
  return 'Managed';
}
